//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { useQuery } from "@tanstack/react-query";
import apiClients from "../../api/apiclients";
import { useProjectDetailsContext } from "../project/ProjectDetailsContextProvider";

export const useFetchArangoPlatformBundles = ({ regionId }: { regionId: string }) => {
  const { project } = useProjectDetailsContext();
  const organizationId = project.organization_id || "";

  const fetchArangoPlatformBundles = async () => {
    const req = {
      organization_id: organizationId,
      region_id: regionId || "",
    };
    return await apiClients.dataClient.ListArangoPlatformBundles(req);
  };

  return useQuery([project.id, organizationId, regionId, "arangoPlatformBundles"], fetchArangoPlatformBundles, {
    enabled: !!project.id && !!organizationId && !!regionId,
  });
};
